import { render, staticRenderFns } from "./FreeRemnant.vue?vue&type=template&id=6be55468&scoped=true&"
import script from "./FreeRemnant.vue?vue&type=script&lang=js&"
export * from "./FreeRemnant.vue?vue&type=script&lang=js&"
import style0 from "./FreeRemnant.vue?vue&type=style&index=0&id=6be55468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be55468",
  null
  
)

export default component.exports